import React from "react";
import { useNavigate } from "react-router-dom";
import { Create, GetRoomType } from "adminApi/PromoCodeApi/Promocode";
import { validateForm } from "utils/validation";
import { PromoCodeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPromoCodeForm from "./Componates/AddPromoCodeForm";
import fields from "../json/PromoCodeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddPromoCode = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, handleFileChange } = useFormChange(initialValues, PromoCodeRules);

  // Fetch room types for the select dropdown
  const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(GetRoomType);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send FormData for file uploads like User module
    async (formValues) => {
      const formData = new FormData();
      delete formValues.imagePreview;
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, PromoCodeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Promo Code Created successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingRoomType) && <Spinner isSpinner={true} />}
      <AddPromoCodeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        roomTypeOptions={roomTypeOptions || []}
        title="Add Promo Code"
        handleFileChange={handleFileChange}
        imagePreview={values.imagePreview || values.image}
      />
    </>
  );
};

export default AddPromoCode;
